module.exports = __webpack_public_path__ + "static/media/stc-3x.1a44e643.png";